import { render } from "./OverviewPage.vue?vue&type=template&id=3eee5d2c&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"

import "./OverviewPage.vue?vue&type=style&index=0&id=3eee5d2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eee5d2c"]])

export default __exports__